import { GenericClass, GenericFilter } from './genericClass';

export class Group extends GenericClass {
    companyName: string;

    address: string;
    postalCode: string;
    city: string;
    state: string;
    country: string;

    showLogo: boolean;
    idLogo: number;

    idAppPlanType: number;

    idsPhasesAllowed: number[];
    idsRolesNeedCertificate: number[];
    idsVariablesCalibrates: number[];

    maxUsers: number;
    maxExecutions: number;
    canGeneratePreReport: boolean;
    canManageUsers: boolean;

    automaticSign: boolean;
    manualSign: boolean;

    showCharacterization: boolean;
    showExternalEquipments: boolean;

    showClone: boolean;
	requireProcessApproval: boolean;
    showCanCloneExecutions: boolean;
    showCanCloneCharacterization: boolean;
	showCanCalibrationPlanAnnual: boolean;
    showCanBalance: boolean;
    groupDocumentCoding: GroupDocumentCoding[];

    showHeader: boolean;
    idHeader: number;

    showFooter: boolean;
    idFooter: number;

    reportColumnI18ns: ReportColumnI18n[] = [];
    
    getFullAddress(): string {
        return this.getAddressLine1() + '\n' + this.getAddressLine2();
    }

    getAddressLine1(): string {
        return [this.address].filter(f => f != null).join(', ');
    }

    getAddressLine2(): string {
        return [this.postalCode, this.city, this.state, this.country].filter(f => f != null).join(', ');
    }

}

export class GroupFilter extends GenericFilter {
    name: string;
}

export class GroupDocumentCoding {
    id: number;
    idGroup: number;
    idAppType: number;
    coding: string;
    documentType: number;
}

export class ReportColumnI18n {
    id: number;
    key: string;
    lang: string;
    idReportType: number;
    translation: string;
    idGroup: number;
}

export enum ReportColumnI18Enum {
    ESSAYS_TITLE = "ejecucion_aire.essays.title",
    DEVIATIONS_TITLE = "ejecucion_aire.deviations.title",
    OBSERVATIONS_TITLE = "ejecucion_aire.observations.title",
    OBSERVATIONS_NOT_FOUND = "report.observations.notFound",
    DEVIATIONS_NOT_FOUND = "report.deviations.notFound"
}